export default __webpack_public_path__ + "static/virtualization-81f333fc02135cc37f29cbf157065596.jpg";